

import React from 'react';
import Sectiontop from './index';
import History from './history';

const ViewHistory = () => {


  return (
    <>
      <Sectiontop/>
      <History/>
    </>
  );
};

export default ViewHistory;
